import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollTo from 'vue-scrollto';
import VueTypedJs from 'vue-typed-js';
import VueGtag from "vue-gtag";

import App from '@/App.vue'

import '@/css/bootstrap.min.css';
import '@/css/et-line-fonts.css';
import '@/css/ionicons.min.css';
import '@/css/magnific-popup.css';
import '@/css/meanmenu.css';
import '@/css/global.css';
import '@/css/style.css';
import '@/css/responsive.css';
import '@/css/animate.css';

import '@/js/vendor/jquery-1.12.0.min.js';
import '@/js/bootstrap.min.js';
import '@/js/jquery.meanmenu.js';

import router from '@/router/router.js';

Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(VueTypedJs)
Vue.use(VueGtag, {
  config: { id: "UA-179486348-1" }
}, router);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
